/* eslint-disable no-unused-vars */
import React, { useState } from "react";

export default function PCalendarDateSelector(props) {
  const [isAllDateSelected, setAllDateSelected] = useState(false);

  return (
    <table width="100%">
      <tr>
        <td
          style={{
            color: props.calenderDate[0].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[0].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[0] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[0] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          1
        </td>
        <td
          style={{
            color: props.calenderDate[1].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[1].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[1] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[1] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          2
        </td>
        <td
          style={{
            color: props.calenderDate[2].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[2].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[2] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[2] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          3
        </td>
        <td
          style={{
            color: props.calenderDate[3].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[3].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[3] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[3] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          4
        </td>
        <td
          style={{
            color: props.calenderDate[4].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[4].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[4] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[4] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          5
        </td>
        <td
          style={{
            color: props.calenderDate[5].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[5].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[5] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[5] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          6
        </td>
      </tr>
      <tr>
        <td
          style={{
            color: props.calenderDate[6].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[6].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[6] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[6] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          7
        </td>
        <td
          style={{
            color: props.calenderDate[7].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[7].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[7] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[7] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          8
        </td>
        <td
          style={{
            color: props.calenderDate[8].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[8].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[8] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[8] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          9
        </td>
        <td
          style={{
            color: props.calenderDate[9].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[9].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[9] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[9] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          10
        </td>
        <td
          style={{
            color: props.calenderDate[10].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[10].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[10] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[10] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          11
        </td>
        <td
          style={{
            color: props.calenderDate[11].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[11].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[11] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[11] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          12
        </td>
      </tr>
      <tr>
        <td
          style={{
            color: props.calenderDate[12].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[12].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[12] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[12] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          13
        </td>
        <td
          style={{
            color: props.calenderDate[13].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[13].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[13] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[13] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          14
        </td>
        <td
          style={{
            color: props.calenderDate[14].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[14].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[14] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[14] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          15
        </td>
        <td
          style={{
            color: props.calenderDate[15].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[15].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[15] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[15] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          16
        </td>
        <td
          style={{
            color: props.calenderDate[16].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[16].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[16] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[16] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          17
        </td>
        <td
          style={{
            color: props.calenderDate[17].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[17].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[17] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[17] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          18
        </td>
      </tr>
      <tr>
        <td
          style={{
            color: props.calenderDate[18].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[18].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[18] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[18] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          19
        </td>
        <td
          style={{
            color: props.calenderDate[19].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[19].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[19] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[19] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          20
        </td>
        <td
          style={{
            color: props.calenderDate[20].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[20].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[20] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[20] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          21
        </td>
        <td
          style={{
            color: props.calenderDate[21].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[21].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[21] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[21] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          22
        </td>
        <td
          style={{
            color: props.calenderDate[22].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[22].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[22] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[22] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          23
        </td>
        <td
          style={{
            color: props.calenderDate[23].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[23].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[23] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[23] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          24
        </td>
      </tr>
      <tr>
        <td
          style={{
            color: props.calenderDate[24].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[24].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[24] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[24] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          25
        </td>
        <td
          style={{
            color: props.calenderDate[25].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[25].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[25] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[25] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          26
        </td>
        <td
          style={{
            color: props.calenderDate[26].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[26].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[26] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[26] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          27
        </td>
        <td
          style={{
            color: props.calenderDate[27].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[27].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[27] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[27] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          28
        </td>
        <td
          style={{
            color: props.calenderDate[28].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[28].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[28] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[28] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          29
        </td>
        <td
          style={{
            color: props.calenderDate[29].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[29].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[29] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[29] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          30
        </td>
      </tr>
      <tr>
        <td
          style={{
            color: props.calenderDate[30].isSelected ? "#ffffff" : "#000000",
            background: props.calenderDate[30].isSelected
              ? "#3282b8"
              : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            let tempItem = { ...props.calenderDate[30] };
            tempItem.isSelected = !tempItem.isSelected;
            tempCalenderDate[30] = tempItem;
            props.setCalenderDate(tempCalenderDate);
          }}
        >
          31
        </td>
        <td
          colSpan={2}
          style={{
            color: isAllDateSelected ? "#ffffff" : "#000000",
            background: isAllDateSelected ? "#3282b8" : "#ffffff",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={(e) => {
            let tempCalenderDate = [...props.calenderDate];
            props.calenderDate.map((dateObj) => {
              let tempItem = { ...tempCalenderDate[dateObj.index] };
              tempItem.isSelected = !isAllDateSelected;
              tempCalenderDate[dateObj.index] = tempItem;
            });
            props.setCalenderDate(tempCalenderDate);
            setAllDateSelected(!isAllDateSelected);
          }}
        >
          {isAllDateSelected ? "Unselect-All" : "Select-All"}
        </td>
      </tr>
    </table>
  );
}
